<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  {{data.message}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" mat-dialog-close="cancel" class="dialog-button">キャンセル</button>
  <button mat-raised-button color="primary" id="ok-button" class="dialog-button" (click)="okClick()">OK</button>
</mat-dialog-actions>
